export var valuesWikiColumnType = ["Image", "Video", "Audio", "Table", "Text"];
/*

*/ 
//# sourceMappingURL=WikiColumnType.js.map